import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ModuleTokens } from './client-user-base.constant';
import { reducer } from './client-user-base.reducer';
import { ClientUserBaseEffect } from './client-user-base.effect';

@NgModule({
  imports: [
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    ),
    EffectsModule.forFeature([ ClientUserBaseEffect ])
  ]
})
export class ClientUserBaseModule {

}
